import React, { useEffect } from 'react';
import { Dashboard } from 'pages';
import { Header } from 'components/common';

const App = () => {
  return (
    <div className="App">
      <Header />
      <Dashboard />
    </div>
  );
};
export default App;
